export default __webpack_public_path__ + "static/media/HalffilledCircle.7257b29d.svg";